export default __webpack_public_path__ + "static/media/cart.ff64f615.svg";